
angular.module('picsPreviewRebuildModule', []).directive('picsPreview', [
    '$state',
    'messagePublishService',
    'editingCenterService',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    '$window',
    'mrApiService',
    'resCtrModalService',
    '$q',
    function ($state, messagePublishService, editingCenterService, $timeout, trsHttpService, modalDialog, $window, mrApiService, resCtrModalService, $q) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/picsPreview/picsPreview.html',
            replace: true,
            link: function ($scope) {
                getRightForCheckPic();
                initData();
                initLightgallery();

                /**
                 * [initData description]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    $scope.mrtype = $state.params.mrtype;
                    // 查看原图权限
                    $scope.hasCKPicRights = {};
                    $scope.status.muduleList = 'picsDesc';
                    $scope.currentName = $state.current.name.split('.')[0];
                }


                /**
                 * [chooseModule description]
                 *
                 * @param   {[type]}  mudule  [mudule description]
                 *
                 * @return  {[type]}          [return description]
                 */
                $scope.chooseModule = function (mudule) {
                    $scope.status.muduleList = mudule;
                };

                /**
                * [openPicsInfo description]
                *
                * @param   {[type]}  data  [data description]
                *
                * @return  {[type]}        [return description]
                */
                $scope.openPicsInfo = function (data) {
                    editingCenterService.picsPreviewShowMoreInfo(data).then();
                };
                $scope.openUrl = function (url) {
                    window.open(url);
                };

                /**
                 * [getRightForCheckPic description] 获取查看原图权限，
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                function getRightForCheckPic() {
                    if (!$scope.status.comefrom) {
                        return;
                    }
                    var deffer = $q.defer();
                    var params = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'queryOperKeysOfNormalModal',
                        ModalName: '资源中心',
                        Classify: $scope.status.comefrom,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        angular.forEach(data, function (value, key) {
                            $scope.hasCKPicRights[value.OPERNAME] = value;
                            // if (value.OPERNAME === 'source.sharedoc.chakanyuantu') {
                            //     $scope.hasRights = true;
                            // }
                        });
                        deffer.resolve();
                    });
                    return deffer.promise;
                }

                $scope.downPic = function(e) {
                    // e.stopPropagation();
                    $scope.downLoad();
                };

                /**
                * [addToPersonal description]
                *
                * @param   {[type]}  index  [index description]
                * @param   {[type]}  text   [text description]
                *
                * @return  {[type]}         [return description]
                */
                function addToPersonal(index, text) {
                    if ($state.params.mrtype) {
                        $scope.moveToPersonalMaterial();
                        return;
                    }
                    var descArr = $scope.data.item ? $scope.data.item.DOC_PICTURELIST : ($scope.detailInfos.imgList || $scope.detailInfos.imgList || $scope.detailInfos.DOC_PICTURELIST || $scope.detailInfos.IMGURLS || $scope.data.items);
                    var newFileName = (descArr[text].PERPICURL || descArr[text].perpicurl || descArr[text].previewurl).split('/');
                    mrApiService.addToPersonel(
                        {
                            mrType: 'personal',
                            mainResourceType: '0',
                            fileName: newFileName[newFileName.length - 1],
                            tempUrl: descArr[text].PERPICURL || descArr[text].perpicurl
                        }
                    )
                        .then(function (data) {
                            if (data.code === '200') {
                                modalDialog.alertType('添加成功', '', 'success', false);
                                $window.document.getSelection().collapse($window.document, 1);
                            } else {
                                modalDialog.alertType('', data.msg, 'error', false);
                            }
                        });


                }

                /**
                 * [initLightgallery description]
                 *
                 * @return  {[type]}  [return description]
                 */
                function initLightgallery() {
                    // var isInsert = false;
                    $timeout(function () {
                        setTimeout(() => {
                            $('#lightgallery').lightGallery({
                                showThumbByDefault: false,
                                thumbWidth: 200,
                                thumbHeight: '200px',
                            });
                            $('#lightgallery').on('onSlideItemLoad.lg', function (event, index) {
                                $('.new-img-wrap .lg-add-to-personal').remove();
                                $('.new-img-wrap .lg-add-to-takedraft').remove();
                                $('.lg-toolbar .lg-check-pic').remove;
                                if ($state.params.mrtype !== 'personal') {
                                    $('.new-img-wrap').prepend('<a class="lg-add-to-personal">添加到个人素材</a>');
                                }
                                $('a.lg-check-pic').click(() => {
                                    var descArr = $scope.data.item ? $scope.data.item.DOC_PICTURELIST : $scope.detailInfos.imgList || $scope.detailInfos.imgList || $scope.detailInfos.DOC_PICTURELIST || $scope.detailInfos.IMGURLS;
                                    var url = descArr[Number($('#lg-counter-current').text()) - 1].SRCPICURL;
                                    if (index === Number($('#lg-counter-current').text()) - 1) {
                                        window.open(url);
                                    }   
                                });
                                // 共享稿库和新华社有取稿按钮
                                if ((!$scope.status.isFromPictures && ($scope.currentName === 'resourcegxgkdetail' || $scope.currentName === 'resourcedetail')) || $scope.currentName === 'resourcexhsgbigdatadetail' || $state.params.mrtype) {
                                    $('.new-img-wrap').prepend('<a class="lg-add-to-takedraft">取稿</a>');
                                }
                                $('a.lg-add-to-personal').click(() => {
                                    addToPersonal(index, Number($('#lg-counter-current').text()) - 1);
                                });
                                $('a.lg-add-to-takedraft').click(() => {
                                    if ($state.params.mrtype) {
                                        $scope.takeDoc();
                                        return;
                                    }
                                    $scope.openTakeDraftModal('picsPreview');
                                });
                            });
                            $('#lightgallery').on('onAfterOpen.lg', function(event) {
                                if ($scope.hasCKPicRights['source.sharedoc.chakanyuantu'] || $scope.hasCKPicRights['source.xinhuadoc.chakanyuantu']) {
                                    $('.lg-toolbar').append('<a class="lg-check-pic">查看原图</a>');
                                }
                            });
                        }, 500);
                    });
                }
            },
        };
    },
]);
